var handler = {
  construct: function construct() {
    return handler;
  }
};
export var isConstructible = function isConstructible(constructible) {
  try {
    var proxy = new Proxy(constructible, handler);
    new proxy(); // tslint:disable-line:no-unused-expression
  } catch (_unused) {
    return false;
  }
  return true;
};